import { useState } from "react";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import { API } from "../../config";
import { molliePost } from "../../lib/mollieCheckout";

// Abonnement web Mollie : renouvellement automatique et résiliation
export function WebSubscriptionCard({ user, setUser, en }) {
  const [busy, setBusy] = useState(false);
  const sub = user?.subscription;
  if (sub?.source !== "mollie" || !sub?.mollie_subscription_id) return null;
  const end = new Date(sub.expires_at).toLocaleDateString(en ? "en-GB" : "fr-FR");
  const renewing = sub.auto_renew !== false;

  const cancel = async () => {
    if (!window.confirm(en ? "Cancel automatic renewal?" : "Résilier le renouvellement automatique ?")) return;
    setBusy(true);
    try {
      const d = await molliePost(`${API}/payments/mollie/cancel-subscription`);
      setUser((prev) => ({ ...prev, subscription: { ...prev.subscription, auto_renew: false } }));
      toast.success(d.message);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-8" data-testid="web-subscription-card">
      <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">
        {en ? "Subscription" : "Abonnement"}
      </h2>
      <div className="bg-card/50 backdrop-blur-sm border border-white/5 rounded-2xl p-4 flex items-center gap-4">
        <div className="w-10 h-10 rounded-xl bg-yellow-500/20 flex items-center justify-center">
          <Crown className="w-5 h-5 text-yellow-500" />
        </div>
        <div className="flex-1">
          <p className="text-white font-medium">Premium {sub.plan === "premium_weekly" ? (en ? "Weekly" : "Hebdo") : (en ? "Monthly" : "Mensuel")}</p>
          <p className="text-sm text-muted-foreground" data-testid="web-subscription-status">
            {renewing ? (en ? `Renews automatically · ${end}` : `Renouvellement automatique · ${end}`)
              : (en ? `Cancelled · active until ${end}` : `Résilié · actif jusqu'au ${end}`)}
          </p>
        </div>
        {renewing && (
          <button onClick={cancel} disabled={busy} className="text-sm text-red-400 hover:text-red-300" data-testid="web-subscription-cancel-btn">
            {en ? "Cancel" : "Résilier"}
          </button>
        )}
      </div>
    </div>
  );
}
